import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { useEffect } from "react";
import { useTranslations } from "use-intl";
import { TransactionFullScreen } from "../../../../../components/TransactionFullScreen";
import { FlowActions } from "../../../../../stores/flowStore";
export const DropPublishStatusCollectionFragment = graphql(`
  fragment DropPublishStatusCollection on Collection {
    imageUrl
  }
`);
export function DropPublishStatus(t0) {
  const $ = _c(25);
  const {
    collection: collectionKey,
    success
  } = t0;
  const t = useTranslations("wallet.DropPublishStatus");
  let t1;
  if ($[0] !== collectionKey) {
    t1 = readFragment(DropPublishStatusCollectionFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  let t2;
  let t3;
  if ($[2] !== success) {
    t2 = function handleSuccess() {
      if (success) {
        FlowActions.onSuccess();
      }
    };
    t3 = [success];
    $[2] = success;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  if (success) {
    let t4;
    if ($[5] !== t) {
      t4 = t("success.description");
      $[5] = t;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== collection.imageUrl) {
      t5 = [collection.imageUrl];
      $[7] = collection.imageUrl;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== t) {
      t6 = t("success.title");
      $[9] = t;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    let t7;
    if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
      t7 = <TransactionFullScreen body={t4} confetti={true} images={t5} title={t6} />;
      $[11] = t4;
      $[12] = t5;
      $[13] = t6;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    return t7;
  }
  let t4;
  if ($[15] !== t) {
    t4 = t("failed.description");
    $[15] = t;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== collection.imageUrl) {
    t5 = [collection.imageUrl];
    $[17] = collection.imageUrl;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t) {
    t6 = t("failed.title");
    $[19] = t;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t4 || $[22] !== t5 || $[23] !== t6) {
    t7 = <TransactionFullScreen body={t4} images={t5} monochrome={true} title={t6} />;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}